import {forwardRef, HTMLAttributes} from 'react'
import {cn} from '@utilities/helpers'
import {
    SETTINGS_CARD_COMPLETED_CLASSNAME,
    SETTINGS_CARD_DASHED_BORDER_BACKGROUND,
    SETTINGS_CARD_WRAPPER_CLASSNAME
} from '@features/settings/constants.ts'

export const SettingsCard = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement> & {isCompleted: boolean}>(
    ({isCompleted, className, style, ...props}, ref) => (
        <div
            ref={ref}
            className={cn(SETTINGS_CARD_WRAPPER_CLASSNAME, isCompleted && SETTINGS_CARD_COMPLETED_CLASSNAME, className)}
            style={isCompleted ? style : {backgroundImage: SETTINGS_CARD_DASHED_BORDER_BACKGROUND, ...style}}
            {...props}
        />
    )
)
